import { render, staticRenderFns } from "./IconButton.vue?vue&type=template&id=1293a00e&scoped=true&"
import script from "./IconButton.vue?vue&type=script&lang=js&"
export * from "./IconButton.vue?vue&type=script&lang=js&"
import style0 from "./IconButton.vue?vue&type=style&index=0&id=1293a00e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1293a00e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dilan/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1293a00e')) {
      api.createRecord('1293a00e', component.options)
    } else {
      api.reload('1293a00e', component.options)
    }
    module.hot.accept("./IconButton.vue?vue&type=template&id=1293a00e&scoped=true&", function () {
      api.rerender('1293a00e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PUI/Controls/IconButton.vue"
export default component.exports